import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaDateNode } from './TypedNode'
import { SchemaDateModel } from './ViewModel'

export const SchemaDatePlugin = createSchemaPlugin(
  'Schema.Date',
  SchemaDateModel,
  SchemaDateNode
)
